<div class="table-container gray">

  <div class="filter" [class.white-background]="value" *ngIf="showBuiltInSearch">
    <mat-form-field class="search-field">
      <mat-icon matPrefix style="padding-top: 0px; padding-left: 10px;">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target['value'])" placeholder="" [(ngModel)]="value">
      <mat-icon *ngIf="value" matSuffix (click)="value=''; applyFilter($event.target['value'])" class="clear">close
      </mat-icon>
    </mat-form-field>
  </div>

  <div class="title">
    <h4 *ngIf="title && !isMobile">{{ title }}</h4>
  </div>

  <app-action-button-toolbar class="topbar-action-buttons" [actionButtons]="topbarActionButton">
  </app-action-button-toolbar>

  <ng-container *ngIf="dataSourceFiltered$ | async as ds; else loadingSpinner">
  <ng-container *ngIf="!forceLoading; else loadingSpinner">
    <table  mat-table [dataSource]="ds" [trackBy]="trackByRow" matSort>

      <ng-container *ngFor="let columnSetting of columnSettings" [matColumnDef]="columnSetting.columnId">
        <th class="gray .mat-header-cell" mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="columnSetting.align">
          {{columnSetting.name}}</th>
        <td mat-cell class=".mat-cell" *matCellDef="let element" [ngStyle]="{'color':element[columnSetting.columnId]}"
          [matTooltip]="toolTipFilter(element[columnSetting.columnId], columnSetting.maxLengthOnMobile)">
          <div *ngIf="shortenString(element[columnSetting.columnId], columnSetting.maxLengthOnMobile); let text"
            [ngClass]="columnSetting.align" [ngClass]="columnSetting.class">
            <div *ngIf="columnSetting.type == 'url'">
              <a href="{{text}}" target="_blank">{{columnSetting.type}}</a>
            </div>
            <div *ngIf="columnSetting.type == 'emitter'; else otherType">
              <input class="form-control" type="text" [ngModel]="text1"
                (ngModelChange)="updateRow($event,element,element.emitter)">
            </div>
            <ng-template #otherType>
              <span (click)="click(columnSetting.listener,element)" [class.live-badge]="text === 'Live'"> {{ columnSetting.titlecase ? (text | titlecase) :
                text }} </span>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="rowActionButtons" matColumnDef="actionButtons">
        <th class="gray" mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td class="row-action-buttons-cell" mat-cell *matCellDef="let element">
          <app-action-button-toolbar [actionButtons]="rowActionButtons" [eventData]="element">
          </app-action-button-toolbar>
        </td>
      </ng-container>

      <tr mat-header-row class=".mat-header-row" *matHeaderRowDef="displayedColumnsList"></tr>
      <tr mat-row [ngClass]="row.rowClass" *matRowDef="let row; columns: displayedColumnsList"></tr>
    </table>
  </ng-container>
  </ng-container>
  <ng-template #loadingSpinner>
    <app-spinner-loading></app-spinner-loading>
  </ng-template>

  <mat-paginator class="gray" [pageSizeOptions]="[500,1000,2000]" showFirstLastButtons></mat-paginator>
</div>
<!-- </div> -->